export const toBackendWidgetRef = ({ widgetId: widgetId2, dashboardId, title, description, height }) => ({
  dashboard_id: dashboardId,
  dashboard_widget_id: widgetId2,
  title,
  description,
  height
});
export const widgetId = (widget, dashboard) => ({
  widgetId: widget.id,
  dashboardId: dashboard.id
});
export const compareWidgetRefs = (widgetRef1, widgetRef2) => widgetRef1.widgetId === widgetRef2.widgetId && widgetRef1.dashboardId === widgetRef2.dashboardId;
